import React from 'react';
import * as FiIcons from 'react-icons/fi';

const SafeIcon = ({ icon, className }) => {
  const IconComponent = icon || FiIcons.FiAlertCircle;
  return <IconComponent className={className} />;
};

export default SafeIcon;